import { render, staticRenderFns } from "./SellerCallLogs.vue?vue&type=template&id=6c3ff23a&scoped=true"
import script from "./SellerCallLogs.vue?vue&type=script&lang=js"
export * from "./SellerCallLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3ff23a",
  null
  
)

export default component.exports